export const isFigmaOnlyTheme = (tag: string[]) => tag.length === 1 && tag[0] === "Figma";

export const isOpenSourceTheme = (
  excludeSlug: any,
  blogDetailsRelatedPosts: any,
  filteredData: any,
  shopifyThemesData: any
) => {
  const openSourceData: any = [];
  const randomOpenSourceData: any = [];
  const randomPaidShopifyThemes: any = [];

  //filter open-source shopify only themes
  filteredData.forEach((themeData: any) => {
    if (themeData.node.frontmatter.author != "Polo Themes") {
      themeData.node.frontmatter.technologies.forEach(
        (tech: { title: string; class: string }) => {
          if (tech.title == "Shopify") {
            openSourceData.push(themeData);
          }
        }
      );
    }
  });

  if (!blogDetailsRelatedPosts) {
    //return themes for open-source section in home page
    return openSourceData;
  } else {
    const currentThemeExcluded = openSourceData.filter((themeData: any) => {
      if (themeData.node.frontmatter.slug != excludeSlug) return themeData;
    });

    if (shopifyThemesData.length <= 2) {
      filteredData = [...shopifyThemesData];
    } else {
      while (randomPaidShopifyThemes.length < 2) {
        const randomShopifyTheme = shopifyThemesData[Math.floor(Math.random() * shopifyThemesData.length)];
        
        const themeExists = randomPaidShopifyThemes?.some(
          (theme: any) =>
            theme.node.frontmatter.title ===
            randomShopifyTheme.node.frontmatter.title
        );
  
        if (!themeExists) randomPaidShopifyThemes.push(randomShopifyTheme);
      }

      filteredData = [...randomPaidShopifyThemes];
    }

      while (filteredData.length < 3) {
        const randomOpenSourceTheme =
        currentThemeExcluded[Math.floor(Math.random() * currentThemeExcluded.length)];

        const freeThemeExists = randomOpenSourceData?.some(
          (theme: any) =>
            theme.node.frontmatter.title ===
            randomOpenSourceTheme.node.frontmatter.title
        );

        if (!freeThemeExists) {
          randomOpenSourceData.push(randomOpenSourceTheme);
          filteredData.push(randomOpenSourceTheme)
        }
      }


    return filteredData;
  }
};
